export enum SnackBarType {
  ERROR = 'ERROR',
}
